var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap wrap--sub"
  }, [_c('sub-visual', {
    attrs: {
      "visual": '마이페이지'
    }
  }), _c('mypage-navigation'), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('tit-primary', {
    attrs: {
      "sc": "".concat(_vm.type, " SUPPORT"),
      "tit": _vm.title
    }
  }), _c('router-view', {
    attrs: {
      "name": "service-application"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }